import isSeatChosen from './isSeatChosen';

export default function getSeatStatus({
  bookingData, direction, seat, chosenSeats, wagonNumber,
}) {
  if (seat?.status === 'sold') {
    return 'sold';
  }
  if (isSeatChosen({
    chosenSeats,
    seat,
    wagonNumber,
  })) {
    return 'marked';
  }

  const searchedSeat = bookingData?.[direction]?.chosenAvailableSeatsClasses?.find(
    (availableSeatClass) => availableSeatClass?.seatClass?.id === seat?.seat_class_id,
  );

  if (searchedSeat) {
    return 'available';
  }

  if (bookingData?.[direction]?.chosenAvailableSeatsGroups
    ?.find(
      (availableSeatClass) => availableSeatClass?.seatGroupProperty?.id
                === seat?.seat_group_property_id,
    )) {
    return 'available';
  }

  return 'unavailable';
}
